<template>
  <el-popover placement="bottom-start" width="342" trigger="manual" v-if="onlyValue" v-model="isFoucs" :disabled="readonly" popper-class="long-text-popover">
    <el-input type="textarea" :autosize="{ minRows: 13, maxRows: 13}" @blur="setBlurFoucs()" ref="inputLongText" resize="none" :placeholder="'请输入'" v-bind="$props" v-model="currentValue" @change="changeVal" />
    <div slot="reference" :class="{'show-txt-rest':readonly,'blur-border': isFoucs,'visible-onlyValue': currentValue}" class="table-select-box" @click="getBlur">
      <div class="table-select-onlyValue" v-if="currentValue">
        <toolTip :maxWidth="'100%'" :title="currentValue">
          <span>{{currentValue}}</span>
        </toolTip>
      </div>
      <p v-else class="table-select-button">
        <span v-if="readonly">暂无</span>
        <span v-else><i class="el-icon-circle-plus"></i>添加</span>
      </p>
    </div>
  </el-popover>
  <div v-else-if="currentValue || !readonly" style="width: 100%">
    <div style="width: 100%">
      <div v-if="onlyValue">
        <div :class="{ 'show-txt-rest': readonly }" v-if="!isFoucs" @click="getBlur">
          <div class="only-value" v-if="currentValue && currentValue.length > 0">
            <toolTip class="only-value" :style="{ width: '100%' }" :title="currentValue || '-'">{{ currentValue || "-" }}</toolTip>
            <!-- <p ref="only-value" class="pre" v-html="currentValue || '-'"></p> -->
          </div>
          <span v-else class="add-txt">添加</span>
        </div>
        <el-input v-else clearable type="textarea" ref="inputLongText" resize="none" @blur="setBlurFoucs()" :autosize="{ maxRows: 1 }" :placeholder="'请输入'" v-bind="$props" v-model="currentValue" @change="changeVal" />
      </div>
      <div class="long-text" v-else>
        <div :class="{ 'show-txt-rest': readonly }" ref="show-txt" v-if="!isFoucs" @click="getBlur">
          <div class="only-value show-txt" :style="{ 'max-height': handelMore && inHeight > 140 ? inHeight + 8 + 'px' : '140px' }" id="" v-if="currentValue && currentValue.length > 0">
            <p ref="only-value" class="pre" v-html="currentValue || '-'"></p>
          </div>
          <p v-else class="add-txt">添加</p>
        </div>
        <el-input v-else clearable type="textarea" ref="inputLongText" resize="none" @blur="setBlurFoucs()" :autosize="{ minRows: 6 }" :placeholder="'请输入'" v-bind="$props" v-model="currentValue" @change="changeVal" />
        <div v-if="isMax" class="more-box" @click="handelMore = !handelMore">
          <div class="more-msg" v-if="!handelMore">查看更多<i class="icon iconfont iconicon_arrow_task"></i></div>
          <div class="more-msg" v-else>收起<i class="icon iconfont iconicon_arrow_task2"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["config", "value", "defaultValue", "onlyValue", "readonly", 'isTemplate'],
  data() {
    return {
      date: "",
      isFoucs: false,
      isMax: false,
      handelMore: false,
      inHeight: 0,
      show: false
    };
  },
  computed: {
    currentValue: {
      get: function () {
        if (!this.value) {
          this.isMax = false;
        }
        return this.value;
      },
      set: function (newValue) {
        if (newValue.replace(/\s+|[\r\n]/g, "").length === 0) {
          this.$emit("input", "");
        } else {
          this.$emit("input", newValue || null);
        }
      },
    },
  },
  created() {
    this.init();
  },
  mounted() {
    !this.onlyValue && this.handelChange();
  },
  methods: {
    handelChange() {
      this.$nextTick(() => {
        if (!this.$refs["show-txt"] || !this.$refs["only-value"]) {
          return;
        }
        if (!this.$refs["only-value"]) {
          this.isMax = false;
        }
        let ele = this.$refs["only-value"];
        let inHeight = ele.offsetHeight;
        this.inHeight = inHeight;
        if (inHeight > 140) {
          this.isMax = true;
        } else {
          this.isMax = false;
        }
      });
    },
    getBlur() {
      if (this.readonly) return;
      this.isFoucs = true;
      this.handelMore = true;
      this.$nextTick(() => {
        this.$refs.inputLongText.focus();
      });
    },
    init() {
      if(this.isTemplate) {
        this.$emit("input", this.defaultValue)
      } else if (this.defaultValue && this.defaultValue.length > 0) {
        let val = this.getDefaultValue(this.defaultValue);
        this.$emit("input", val)
      }
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val[0].component_value;
      }
    },
    getMessage(res) {
      return `
      <span class="message-mixin-tip">将${res.field_name}修改为</span>
      <span class="message-mixin-task rich-message">${res.new_data || `<span class="message-mixin-tip">无</span>`}</span>`
    },
    changeVal(val, lr) {
      this.$emit("change", val, lr);
    },
    setBlurFoucs() {
      this.isFoucs = false;
      !this.onlyValue && this.handelChange();
      // this.handelMore = false
    },
    dowen() {
      console.log(666);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.table-select-box-longText{
  .el-textarea__inner{
    border:0;
  }
}
.long-text-popover {
  .el-textarea__inner {
    border: 0 none;
  }
}
.long-text {
  // display: flex;
  // flex-direction: column;
  .pre {
    white-space: pre-wrap;
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  .show-txt {
    transition: all 0.3s;
    overflow: hidden;
    padding-left: 8px;
    padding-right: 8px;
    display: block;
  }
  .show-txt:hover {
    @include bgColorOpacity(.04);
  }
  .more-box {
    font-size: 14px;
    color: #509aff;
    padding-left: 8px;
    cursor: pointer;
    padding-top: 10px;
    i {
      font-size: 12px;
      margin-left: 5px;
    }
  }
  .only-value {
    word-wrap: break-word;
    word-break: break-all;
    line-height: 22px;
  }
}
</style>
